import React from "react";
import { useIntl } from "react-intl";

import FormattedMessage from "@components/UI/FormattedMessage";

type Props = {
  label: string;
  onClick: () => void;
};

const FilterOnlyAction = ({ label, onClick }: Props) => {
  const intl = useIntl();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    onClick();
  };

  return (
    <span
      role="button"
      tabIndex={0}
      className="filter-option-only"
      aria-label={`${intl.formatMessage({ id: "Filters.only" })} ${label}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <FormattedMessage id="Filters.only" />
    </span>
  );
};

export default FilterOnlyAction;
